import { Box, Text } from '@factorialco/deprecated-design-system'
import { VisitDetailsFragment } from 'generated/resources/graphql'

import { dateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface Props {
  visit: VisitDetailsFragment
}

function VisitRow({ visit }: Props) {
  const authorName = visit.author?.fullName ?? i18n.t('dashboard.visits.anonymous')

  const date = dateToString(stringToDate(visit.createdAt, 'backend_datetime'), 'ui')

  return (
    <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween">
      <Box width="s120" flexDirection="row">
        <Text.Normal ellipsis>{authorName}</Text.Normal>
      </Box>
      <Text.Normal>{date}</Text.Normal>
    </Box>
  )
}

export default VisitRow
